import React, { useEffect, useMemo, useState } from 'react'

import { PageOutputTabs, TemplateTypes } from '@ublique/components/Template'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { useStripeChartsConfig } from './hooks/useStripeChartsConfig'
import { useDashboardData } from './hooks/useDashboardData'
import { FiltersActions } from '@ublique/platform'
import { PERCENTAGE_SECTION, UNIT_OF_MEASURE_SECTION } from './utils/constants'
import { first, isEmpty } from 'lodash'
import { reduceFilters } from './utils/dataTransformer'
import Loading from '@ublique/components/Loading'

const { PAGE_OUTPUT_CHARTS_TABLE } = TemplateTypes
const DOMAIN_NAME = 'DashboardOperativa'
const OUTPUT_NAME = 'dashboardOperativa'

const DashboardOperativa = () => {
  const { t } = useTranslation('OutputView')
  const { t: commonT } = useTranslation('Common')
  const { scenarioId } = useParams()
  const [uomFilter, setUomFilter] = useState(false)
  const [percentageFilter, setPercentageFilter] = useState(false)
  const [serverFilter, setServerFilter] = useState({})
  const { dashboardData } = useDashboardData({
    scenarioId,
    serverFilter
  })

  const [loading, setLoading] = useState(true)

  // FILTERBAR
  const [showFilters, setShowFilters] = useState(false)
  const [activeFilters, setActiveFilters] = useState()

  useEffect(() => {
    FiltersActions.update(() => ({
      t: commonT,
      servicesConfig: {
        outputName: OUTPUT_NAME,
        instanceId: scenarioId
      },
      onReset: () => {},
      onToggleFilters: () => setShowFilters((show) => !show),
      isActiveFiltersOpened: showFilters,
      onChangeValue: (path, filter) => {
        setActiveFilters(reduceFilters(t, DOMAIN_NAME, filter))

        if (first(path) === PERCENTAGE_SECTION) {
          //client filters
          setPercentageFilter(filter[PERCENTAGE_SECTION])
        } else {
          //server filters
          const serverFilters = { ...filter }
          delete serverFilters[PERCENTAGE_SECTION]
          setServerFilter(serverFilters)
          setUomFilter(filter[UNIT_OF_MEASURE_SECTION])
        }
      },
      keepStateOnSectionChange: true
    }))
    return FiltersActions.reset
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFilters, t])

  const stripeActiveFilters = showFilters ? activeFilters : null

  // ---------------- Tabs
  const centralGraphs = useStripeChartsConfig(dashboardData?.summary, {
    uomFilter,
    isStacked: !percentageFilter
  })

  const centralTab = useMemo(
    () => ({
      page: PAGE_OUTPUT_CHARTS_TABLE,
      tabTitle: t(`${DOMAIN_NAME}.CENTRAL_TAB`),
      className: 'ovs-dashboard-central-tab',
      pageConfig: {
        stripeCharts: centralGraphs,
        stripeTables: []
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [centralGraphs, dashboardData]
  )
  useEffect(() => {
    if (!isEmpty(centralGraphs)) setLoading(false)
  }, [centralGraphs])

  if (loading) return <Loading></Loading>
  return (
    <PageOutputTabs
      className='ovs-dashboard-operativa'
      stripeActiveFilters={stripeActiveFilters}
      stripeMultiTabs={[{ id: 1, stripeTabs: [centralTab] }]}
    />
  )
}

export default React.memo(DashboardOperativa)
